/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Newsletter_TextInputs */



/**
* | output |
* | --- |
* | "Regulatory changes and industry news." |
*
* @param {Footer_Newsletter_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const footer_newsletter_text = /** @type {((inputs?: Footer_Newsletter_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Newsletter_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("法规变化与行业新闻。")
	return /** @type {LocalizedString} */ ("Regulatory changes and industry news.")
});